/**
 * SiteNotFoundCard.js
 *
 * A card displayed when the selected address does not match any existing site in the database.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { RocketLaunchIcon } from '@heroicons/react/24/solid';
import titleCase from '@/utils/titleCase';

SiteNotFoundCard.propTypes = {
  siteData: PropTypes.object.isRequired,
};

/**
 * Displays a message for a site not yet in the system.
 *
 * @param {object} props - Component props.
 * @returns {JSX.Element} The rendered "not found" site card.
 */
function SiteNotFoundCard(props) {
  const { siteData } = props;
  return (
    <div className="bg-cs-blue-100 border border-cs-blue-500 rounded-2xl flex gap-2 items-start px-4 pt-4 pb-5">
      <RocketLaunchIcon className="w-[22px] h-[22px] text-cs-blue-500 shrink-0 mt-0.5" />
      <div className="flex flex-col gap-4 flex-1">
        <div className="flex flex-col gap-4">
          <p className="font-semibold text-base text-gray-700 leading-[1.2] tracking-[-0.17px]">
            Thanks! That site isn&apos;t in our system yet – we&apos;ll help you get started.
          </p>
          <p className="text-base text-gray-700 leading-[1.2] tracking-[-0.16px]">
            We&apos;ll gather the information needed to activate your site. Meanwhile, you can jump
            in and explore the platform.
          </p>
        </div>
        <div className="text-base font-semibold text-gray-700 leading-[1.2] tracking-[-0.16px]">
          <p>{siteData.name}</p>
          <p>{titleCase(siteData.addressLine1 || '')}</p>
          <p>{siteData.city} {siteData.state}, {siteData.zipCode}</p>
        </div>
      </div>
    </div>
  );
}

export default SiteNotFoundCard;
